import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "gallery-modal__stage" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "gallery-modal__caption" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 2,
  class: "gallery-modal__dots"
}
const _hoisted_7 = ["aria-label", "onClick"]
const _hoisted_8 = {
  key: 3,
  class: "gallery-modal__thumbs"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["src", "alt"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_ctx.isOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "gallery-modal",
          role: "dialog",
          "aria-modal": "true",
          "aria-label": _ctx.productName,
          onClick: _cache[3] || (_cache[3] = _withModifiers((...args) => (_ctx.close && _ctx.close(...args)), ["self"]))
        }, [
          _createElementVNode("button", {
            type: "button",
            class: "gallery-modal__close",
            "aria-label": "Close gallery",
            onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.close && _ctx.close(...args)))
          }, " × "),
          (_ctx.images.length > 1)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "gallery-modal__nav gallery-modal__nav--prev",
                "aria-label": "Previous image",
                onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.prev && _ctx.prev(...args)))
              }, " ‹ "))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("img", {
              src: _ctx.images[_ctx.currentIndex],
              alt: `${_ctx.productName} image ${_ctx.currentIndex + 1}`,
              class: "gallery-modal__image"
            }, null, 8 /* PROPS */, _hoisted_3),
            _createElementVNode("p", _hoisted_4, [
              _createTextVNode(" Image " + _toDisplayString(_ctx.currentIndex + 1) + " / " + _toDisplayString(_ctx.images.length) + " ", 1 /* TEXT */),
              (_ctx.activeCaption)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, " — " + _toDisplayString(_ctx.activeCaption), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          (_ctx.images.length > 1)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                class: "gallery-modal__nav gallery-modal__nav--next",
                "aria-label": "Next image",
                onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.next && _ctx.next(...args)))
              }, " › "))
            : _createCommentVNode("v-if", true),
          (_ctx.images.length > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image, index) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: `${image}-${index}`,
                    type: "button",
                    class: _normalizeClass(["gallery-modal__dot", { 'is-active': index === _ctx.currentIndex }]),
                    "aria-label": `Go to image ${index + 1}`,
                    onClick: $event => (_ctx.goTo(index))
                  }, null, 10 /* CLASS, PROPS */, _hoisted_7))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : _createCommentVNode("v-if", true),
          (_ctx.images.length > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image, index) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: `thumb-${image}-${index}`,
                    type: "button",
                    class: _normalizeClass(["gallery-modal__thumb", { 'is-active': index === _ctx.currentIndex }]),
                    onClick: $event => (_ctx.goTo(index))
                  }, [
                    _createElementVNode("img", {
                      src: image,
                      alt: `${_ctx.productName} thumbnail ${index + 1}`
                    }, null, 8 /* PROPS */, _hoisted_10)
                  ], 10 /* CLASS, PROPS */, _hoisted_9))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : _createCommentVNode("v-if", true)
        ], 8 /* PROPS */, _hoisted_1))
      : _createCommentVNode("v-if", true)
  ]))
}